import Helpers from '../helpers';

class Config {
	constructor() {
		this.console = window.console;
		this.snapshotReact = window.snapshotReact;
		this.ajaxurl = window.ajaxurl;
	}

	/**
	 * Send the AJAX request to set "Get Started" seen
	 */
	setSeen() {
		const nonce = this.snapshotReact.requestsData.pluginRequests.nonce;

		fetch( `${ this.ajaxurl }?action=snapshot_set_started_seen&_ajax_nonce=${ nonce }` )
			.then( ( response ) => response.json() )
			.then( ( data ) => data )
			.catch( ( err ) => {
				this.console.error( err );
			} );
	}

	/**
	 * Apply the Config after successful login.
	 *
	 * @param {number} preset
	 * @param {string} noticeId
	 */
	applyConfigAfterGoogleLogin( preset, noticeId ) {
		const snapshotReact = this.snapshotReact;
		const ajaxurl = this.ajaxurl;
		const console = this.console;

		const nonce = snapshotReact.requestsData.pluginRequests.nonce;
		if ( ! nonce ) {
			console.error( 'Cannot verify the nonce!' );
			return;
		}

		const applyConfigFD = new FormData();
		applyConfigFD.append( 'action', 'snapshot_apply_config' );
		applyConfigFD.append( 'id', preset );
		applyConfigFD.append( '_ajax_nonce', nonce );

		const configRequest = fetch( ajaxurl, {
			method: 'POST',
			credentials: 'same-origin',
			body: applyConfigFD
		} );

		configRequest
			.then( ( response ) => response.json() )
			.then( ( res ) => {
				if ( noticeId === 'modal' ) {
					window.SUI.closeModal();
				} else {
					Helpers.Notice.close( noticeId );
				}

				if ( res.success ) {
					let msg = snapshotReact.config_applied;
					msg = msg.replace( '{configName}', `<strong>${ res.data.name }</strong>` );
					const noticeArgs = {
						message: msg,
						type: 'success',
						dismissible: true
					};
					this.setSeen();
					setTimeout( function() {
						Helpers.Notice.open( noticeArgs );
					}, 500 );
				} else {
					setTimeout( () => {
						Helpers.Notice.open( {
							message: res.data.error_msg,
							type: 'error',
							dismissible: true
						} );
					}, 500 );
				}
			} )
			.catch( ( err ) => {
				console.error( err );
				// Display an error if something is wrong.
			} );
	}
}

export default Config;
